<template>
	<div class="container-my-debits">
		<atualizar-dados-cadastrais v-if="getMostrarFormularioDadosCadastrais()"></atualizar-dados-cadastrais>
		<template v-else>
			<div class="header-debits">

				<i v-if="parceiroConfig.sessoes.customization.campos.menuDebits.flgPrefeituraMode"
					:style="{ parceiroConfigCorSecundariaCorPrimaria }" class="fas fa-question"
					@click="$router.push({ name: 'FAQ' })"></i>

				<i v-if="parceiroConfig.sessoes.customization.campos.menuDebits.flgPrefeituraMode"
					:style="{ parceiroConfigCorSecundariaCorPrimaria }" class="fas fa-times"
					@click="$router.push({ name: 'LandPageParceiro' })"></i>

				<i v-else :style="{ parceiroConfigCorSecundariaCorPrimaria }" class="fas fa-times"
					@click="$router.push({ name: 'AccordionTabs' })"></i>

			</div>

			<warning-card v-if="parceiroConfig.sessoes.customization.campos.menuDebits.flgPrefeituraMode"
				key="portal-prefeitura"></warning-card>

			<div v-else key="portal-parceiro" style="display: flex; flex-direction: column; align-items: center">

				<h3 :style="{ parceiroConfigCorSecundariaCorPrimaria }">{{ tituloMinhasDividas }}</h3>

				<p v-if="dividas && dividas.length > 0" key="portal-parceiro-com-dividas" class="message-sub">
					{{ mensagemQuantidadeDeDividas }}</p>

				<p v-else-if="parceiroConfig.sessoes.customization.campos.landPage.flgModoServico"
					key="portal-parceiro-sem-servicos" class="message-sub">
					Você não possui nenhuma solução disponível</p>

				<p v-else key="portal-parceiro-sem-dividas" class="message-sub">{{ mensagemVoceNaoTemDividas }}</p>
				<div v-if="temPix" style="display: flex; flex-direction: column; align-items: center">

					<img src="@/assets/images/pix-106.svg" style="margin-bottom: 10px" />
					<p class="message-sub">Aceitamos pagamentos por PIX.</p>
					<p class="message-sub">Nossa chave PIX: {{
						parceiroConfig.sessoes.customization.campos.myDebits.textChavePix }}</p>
				</div>
			</div>

			<debit-card v-for="(divida, chave) in dividas" :key="chave" :divida="divida"></debit-card>
		</template>
	</div>
</template>

<script>
	import { mapState, createNamespacedHelpers } from "vuex";
	import mixins from "@/mixins/mixins";

	import DebitCard from "./components/DebitCard";
	import Template from "@/views/admin/Template";
	import WarningCard from "./components/WarningCard";

	import AtualizarDadosCadastrais from '../AtualizarDadosCadastrais.vue';

	const {
		mapState: mapStatePassosRetornarDividas,
		mapActions: mapActionsPassosRetornarDividas,
		mapGetters: mapGettersPassosRetornarDividas,
	} = createNamespacedHelpers("passosRetornarDividas");

	export default {
		name: "MyDebits",

		components: { Template, DebitCard, WarningCard, AtualizarDadosCadastrais },

		mixins: [mixins],

		data() {
			return {
				dividas: Array,
				acordosAtivos: 0,
				mostrarTelaAtualizarDadosCadastrais: false
			};
		},

		computed: {
			...mapState({
				empresas: (estado) => estado.empresas,
				lojas: (estado) => estado.passosRetornarDividas.lojas,
			}),

			...mapStatePassosRetornarDividas({
				dadosCadastraisConfirmados: (estado) => estado.dadosCadastraisConfirmados,
				mostrarFormularioDadosCadastrais: (estado) => estado.mostrarFormularioDadosCadastrais,
			}),

			tituloMinhasDividas() {
				return this.parceiroConfig.sessoes.customization.campos.myDebits.textMyDebits ? this.parceiroConfig.sessoes.customization.campos.myDebits.textMyDebits : "Minhas Dívidas";
			},

			pluralOuSingular() {
				return this.parceiroConfig.sessoes.customization.campos.myDebits.subtextPanelMyDebits ?
					this.parceiroConfig.sessoes.customization.campos.myDebits.subtextPanelMyDebits : this.dividas.length === 1 ?
						"dívida pendente" : "dívidas pendentes";
			},

			mensagemQuantidadeDeDividas() {
				return `Você possui ${this.dividas.length} ${this.pluralOuSingular}`;
			},

			mensagemVoceNaoTemDividas() {
				if (this.parceiroConfig.sessoes.customization.campos.myDebits.subtextPanelMyDebitsNotFound) {
					return this.parceiroConfig.sessoes.customization.campos.myDebits.subtextPanelMyDebitsNotFound;
				} else {
					if (this.acordosAtivos > 0) {
						return `Você tem ${this.acordosAtivos} acordo(s) ativo(s), vá para a aba "Meus Acordos" para vê-lo(s) `;
					} else {
						return 'Você não possui dívidas';
					}
				}
			},

			temPix() {
				return this.parceiroConfig.sessoes.customization.campos.myDebits.textChavePix && this.parceiroConfig.sessoes.customization.campos.myDebits.textChavePix != "1";
			}
		},

		created() {
			this.SET_LOADING(true);
			this.$nextTick(async function () {
				this.SET_LOADING_MESSAGE("Carregando suas dívidas.");

				this.dividas = [];

				this.lojas.forEach(loja => {

					this.acaoPasso2ConsultarDividas({
						lojCodigo: loja.loj_codigo,
					}).then(resposta => {
						if (resposta.retorno && resposta.mensagem) {
							// alterações feitas para o portal mostrar os mesmos valores que o CRM
							let contratos = {};
							Object.keys(resposta.mensagem.con_contrato).forEach(conCodigo => {
								let contrato = {
									con_contrato: resposta.mensagem.con_contrato[conCodigo],
									parcelas: {},
								};

								Object.keys(resposta.mensagem.par_vencimento[conCodigo]).forEach(parCodigo => {
									contrato.parcelas[parCodigo] = {};
									contrato.parcelas[parCodigo].par_codigo = parCodigo;
									contrato.parcelas[parCodigo].par_vencimento = resposta.mensagem.par_vencimento[conCodigo][parCodigo];
									contrato.parcelas[parCodigo].fase = resposta.mensagem.fase[conCodigo][parCodigo];
									contrato.parcelas[parCodigo].original = resposta.mensagem.original[conCodigo][parCodigo];
									contrato.parcelas[parCodigo].corrigido = resposta.mensagem.corrigido[conCodigo][parCodigo];
									contrato.parcelas[parCodigo].pre_codigo = resposta.mensagem.pre_codigo[conCodigo][parCodigo];
									contrato.parcelas[parCodigo].par_prestacao = resposta.mensagem.par_prestacao[conCodigo][parCodigo];
								});

								contratos[conCodigo] = contrato;
							});

							this.dividas.push({
								contratos,
								loja,
								totalCorrigido: resposta.mensagem.total_corrigido,
								totalOriginal: resposta.mensagem.total_original,
							});
						} else if (!resposta.retorno && resposta.mensagem == 'Acordo Ativo') {
							this.acordosAtivos = resposta.dados.length;
						}
					}).catch((_) => {
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Erro",
							message: "Erro ao carregar as suas dívidas",
							styleMessage: "danger",
						});
					});
				});

				this.SET_LOADING_MESSAGE("");
				this.SET_LOADING(false);
			});
			this.SET_LOADING(false);
		},

		methods: {
			...mapActionsPassosRetornarDividas(["acaoPasso2ConsultarDividas"]),

			...mapGettersPassosRetornarDividas(["getMostrarFormularioDadosCadastrais"]),

			getSubdominio() {
				return window.location.host.split(".").length > 2;
			},

			irParaMeusAcordos() {
				this.$router.push({ name: 'MyAgreements' });
			}
		}
	};
</script>

<style scoped>
	.container-my-debits {
		padding: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #f3f5f9;
		flex: 1;
		box-sizing: border-box;
	}

	.header-debits {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		box-sizing: border-box;
		width: 100%;
		max-width: 750px;
		cursor: pointer;
	}

	h3 {
		color: var(--backgroundColor);
		font-family: Montserrat-Bold;
		font-size: 28px;
		margin-bottom: 10px;
		text-transform: uppercase;
	}

	.header-debits i {
		font-size: 48px;
		margin: 10px 20px;
		color: var(--backgroundColor);
	}

	.message-sub {
		color: #5b6987;
		font-size: 14px;
		margin-bottom: 10px;
		text-align: justify;
	}
</style>
